export default (reducerFunction, reducerName) => (state, action) => {
  const { meta } = action;
  const isInitializationCall = state === undefined;
  if (meta && meta.reducerName !== reducerName && !isInitializationCall) return state;

  return reducerFunction(state, action);
};
